import { render, staticRenderFns } from "./audience.environments.vue?vue&type=template&id=563fb46c&scoped=true&lang=pug"
import script from "./audience.environments.vue?vue&type=script&lang=js"
export * from "./audience.environments.vue?vue&type=script&lang=js"
import style0 from "./audience.environments.vue?vue&type=style&index=0&id=563fb46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563fb46c",
  null
  
)

export default component.exports